import React, { FC } from 'react';

import {
  StyledCommunityImageBlock,
  StyledCommunityImageLetter,
} from './styled';

interface DefaultCommunityImageProps {
  title: string;
  zoom?: number;
  frame?: boolean;
}

const DefaultCommunityImage: FC<DefaultCommunityImageProps> = ({
  title,
  zoom = 1,
  frame,
}) => (
  <StyledCommunityImageBlock zoom={zoom} frame={frame}>
    <StyledCommunityImageLetter zoom={zoom}>{title}</StyledCommunityImageLetter>
  </StyledCommunityImageBlock>
);

export default DefaultCommunityImage;
